"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const cheminfo_font_1 = require("cheminfo-font");
const react_1 = require("react");
const DispatchContext_1 = require("../../context/DispatchContext");
const ReactTable_1 = __importDefault(require("../../elements/ReactTable/ReactTable"));
function AutomaticAssignmentTable({ data }) {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const assignHandler = (0, react_1.useCallback)((e, row) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch({
            type: 'SET_AUTOMATIC_ASSIGNMENTS',
            payload: { assignments: row.original.assignment },
        });
    }, [dispatch]);
    const COLUMNS = (0, react_1.useMemo)(() => [
        {
            index: 1,
            Header: '#',
            accessor: (_, index) => index + 1,
            style: { width: '1%', maxWidth: '40px', minWidth: '40px' },
        },
        {
            index: 2,
            Header: 'Score',
            accessor: 'score',
        },
        {
            index: 3,
            Header: '',
            style: {
                width: '1%',
                maxWidth: '24px',
                minWidth: '24px',
            },
            id: 'assign-button',
            Cell: ({ row }) => ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "assign-button", onClick: (e) => assignHandler(e, row), children: (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrAssignment, {}) })),
        },
    ], [assignHandler]);
    return ((0, jsx_runtime_1.jsx)(ReactTable_1.default, { data: data, columns: COLUMNS, onClick: assignHandler, enableDefaultActiveRow: true, emptyDataRowText: "No Data" }));
}
exports.default = (0, react_1.memo)(AutomaticAssignmentTable);
